import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Monitor
 *
 * Monitor을 설명하세요.
 */
export const Monitor = types
  .model('Monitor')
  // --------------------------------------------------------------------------
  .props({
    monitorSid: types.identifierNumber,
    monitorDt: types.maybeNull(types.number), // 일자
    monitorTarget: types.optional(types.string, ''), // 대상
    monitorContent: types.maybeNull(types.string), // 내용

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model monitor --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IMonitor }) => {
      const newProps = { ...self, ...props } as IMonitor;
      (Object.keys(newProps) as TMonitorKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMonitor = Instance<typeof Monitor>;
type TMonitorSnapshot = SnapshotOut<typeof Monitor>;

export interface IMonitor extends TMonitor {}
export type TMonitorKeys = keyof TMonitorSnapshot & string;
export interface IMonitorSnapshot extends TMonitorSnapshot {}
export const createMonitor = () => types.optional(Monitor, {} as TMonitor);
